import React, { useState } from "react";
import "./style.scss";
import { formatterUS } from "../../../utils";
import useHandleModal from "../../../hooks/dom/useHandleModal";
import DashboardTresrSmartrAvaxStaking from "../DashboardTresrSmartrAvaxStaking";
import OnStakeTRESRModal from "../DashboardModals/OnStakeTRESRModal";
import OnUnstakeTRESRModal from "../DashboardModals/OnUnstakeTRESRModal";
import ApproveLoadingModal from "../../common/Modals/ApproveLoadingModal";
import {
  APPROVE_STATUS_TEXT,
} from "../../../constant/approveLoadingModal";
import {useAppContext} from "../../../contexts/appContext";
import {useStakingContext} from "../../../contexts/stakingContext";

const DashboardTresrSmartrAvaxStakingWrapper = ({
  onUnstakeLP,
}) => {
  const { user, balances } = useAppContext();
  const { approveLP, stakeLP, stakingBalances } = useStakingContext();
  const [stake, setStake] = useState("");
  const [unstake, setUnstake] = useState("");
  const [isApproved, setIsApproved] = useState(false);

  const handleStakeTRESRModal = useHandleModal();
  const handleStakeSMRTRModal = useHandleModal();
  const handleUnstakeTRESRModal = useHandleModal();
  const handleUnstakeSMRTRModal = useHandleModal();
  const handleApproveStakingTresrModal = useHandleModal();
  const handleApproveStakingSmrtrModal = useHandleModal();

  const onChangeStake = (event) =>
    !isNaN(event?.target?.value) && setStake(event?.target?.value);
  const onChangeUnstake = (event) =>
    !isNaN(event?.target?.value) && setUnstake(event?.target?.value);

  const onApprove = (amount, isTRESR) => {
    isTRESR
      ? handleApproveStakingTresrModal.open()
      : handleApproveStakingSmrtrModal.open();

    approveLP(amount, isTRESR)
      .then(() => {
        setIsApproved(true);
      })
      .catch(() => {
        setIsApproved(false);
        isTRESR
          ? handleApproveStakingTresrModal.close()
          : handleApproveStakingSmrtrModal.close();
        return null;
      });
  };

  const onStakeCloseTRESR = () => {
    handleStakeTRESRModal.close();
    setStake("");
  };
  const onUnstakeCloseTRESR = () => {
    handleUnstakeTRESRModal.close();
    setUnstake("");
  };

  const onStakeCloseSMRTR = () => {
    handleStakeSMRTRModal.close();
    setStake("");
  };
  const onUnstakeCloseSMRTR = () => {
    handleUnstakeSMRTRModal.close();
    setUnstake("");
  };

  const onStakeTRESR = () => {
    //onStakeCloseTRESR();
    onStakeLP(stake, true);
  };
  const onStakeSMRTR = () => {
    //onStakeCloseSMRTR();
    onStakeLP(stake, false);
  };

  const onApproveTRESR = () => {
    handleStakeTRESRModal.close();
    onApprove(stake, true);
  };
  const onApproveSMRTR = () => {
    handleStakeSMRTRModal.close();
    onApprove(stake, false);
  };

  const onUnstakeTRESR = () => {
    onUnstakeCloseTRESR();
    onUnstakeLP(unstake, true);
  };
  const onUnstakeSMRTR = () => {
    onUnstakeCloseSMRTR();
    onUnstakeLP(unstake, false);
  };

  const onCloseApproveStakingLPModal = () => {
    handleApproveStakingTresrModal.close();
    handleApproveStakingSmrtrModal.close();
    setIsApproved(false);
  };

  const onStakeLP = (value, type) => {
    stakeLP(value, type).finally(onCloseApproveStakingLPModal);
  };

  const onClickStakeTRESR = () => handleStakeTRESRModal.open();
  const onClickUnStakeTRESR = () => handleUnstakeTRESRModal.open();

  const onClickStakeSMRTR = () => handleStakeSMRTRModal.open();
  const onClickUnStakeSMRTR = () => handleUnstakeSMRTRModal.open();

  return (
    <div className="DashboardTresrSmartrAvaxStaking__container">
      <DashboardTresrSmartrAvaxStaking
        isTRESR
        balanceLP={formatterUS(balances.balanceLpTRESRAVAX)}
        onClickStake={onClickStakeTRESR}
        onClickUnStake={onClickUnStakeTRESR}
        balanceLPStaked={formatterUS(stakingBalances.balanceLpStakedTRESRAVAX)}
        poolShareCalc={formatterUS(stakingBalances.balanceLpTotalStakedTRESRAVAX)}
        communityLPStaked={stakingBalances.balanceLpCommunityStakedTRESRAVAX}
      />
      <DashboardTresrSmartrAvaxStaking
        balanceLP={formatterUS(balances.balanceLpSMRTRAVAX)}
        onClickStake={onClickStakeSMRTR}
        onClickUnStake={onClickUnStakeSMRTR}
        balanceLPStaked={formatterUS(stakingBalances.balanceLpStakedSMRTRAVAX)}
        poolShareCalc={formatterUS(stakingBalances.balanceLpTotalStakedSMRTRAVAX)}
        communityLPStaked={stakingBalances.balanceLpCommunityStakedSMRTRAVAX}
      />
      {handleStakeTRESRModal.isActive && (
        <OnStakeTRESRModal
          isOpen={handleStakeTRESRModal.isActive}
          onClose={onStakeCloseTRESR}
          onChangeStake={onChangeStake}
          onStake={onApproveTRESR}
          onStakeClose={onStakeCloseTRESR}
          stake={stake}
          setStake={setStake}
          balance={balances.balanceLpTRESRAVAX}
          title="Stake TRESR-AVAX-LP"
          description="Staking increases your Bonus Pool rewards. You can unstake at any time."
          placeholder="0.000 TRESR-AVAX-LP"
          marginTop={45}
        />
      )}

      {handleUnstakeTRESRModal.isActive && (
        <OnUnstakeTRESRModal
          onClose={onUnstakeCloseTRESR}
          isOpen={handleUnstakeTRESRModal.isActive}
          onChangeUnstake={onChangeUnstake}
          onUnstake={onUnstakeTRESR}
          onUnstakeClose={onUnstakeCloseTRESR}
          unstake={unstake}
          setUnstake={setUnstake}
          balance={stakingBalances.balanceLpStakedTRESRAVAX}
          title="Unstake TRESR-AVAX-LP"
          description=""
          placeholder="0.000 TRESR-AVAX-LP"
          marginTop={115}
        />
      )}
      {handleStakeSMRTRModal.isActive && (
        <OnStakeTRESRModal
          isOpen={handleStakeSMRTRModal.isActive}
          onClose={onStakeCloseSMRTR}
          onChangeStake={onChangeStake}
          onStake={onApproveSMRTR}
          onStakeClose={onStakeCloseSMRTR}
          stake={stake}
          setStake={setStake}
          balance={balances.balanceLpSMRTRAVAX}
          title="Stake SMRTR-AVAX-LP"
          description="Staking increases your Bonus Pool rewards. You can unstake at any time."
          placeholder="0.000 SMRTR-AVAX-LP"
          marginTop={50}
        />
      )}
      {handleUnstakeSMRTRModal.isActive && (
        <OnUnstakeTRESRModal
          onClose={onUnstakeCloseSMRTR}
          isOpen={handleUnstakeSMRTRModal.isActive}
          onChangeUnstake={onChangeUnstake}
          onUnstake={onUnstakeSMRTR}
          onUnstakeClose={onUnstakeCloseSMRTR}
          unstake={unstake}
          setUnstake={setUnstake}
          balance={stakingBalances.balanceLpStakedSMRTRAVAX}
          title="Unstake SMRTR-AVAX-LP"
          description=""
          placeholder="0.000 SMRTR-AVAX-LP"
          marginTop={115}
        />
      )}
      {handleApproveStakingTresrModal.isActive && (
        <ApproveLoadingModal
          isOpen={handleApproveStakingTresrModal.isActive}
          statusText={APPROVE_STATUS_TEXT.APPROVE_STAKING_TRESR_LP}
          isApproved={isApproved}
          onClose={onCloseApproveStakingLPModal}
          onNextStep={onStakeTRESR}
        />
      )}
      {handleApproveStakingSmrtrModal.isActive && (
        <ApproveLoadingModal
          isOpen={handleApproveStakingSmrtrModal.isActive}
          statusText={APPROVE_STATUS_TEXT.APPROVE_STAKING_SMRTR}
          isApproved={isApproved}
          onClose={onCloseApproveStakingLPModal}
          onNextStep={onStakeSMRTR}
        />
      )}
    </div>
  );
};

export default DashboardTresrSmartrAvaxStakingWrapper;
